// ------------------------------------
// Constants
// ------------------------------------
export const SET_CUSTOMER_COMPANY = 'SET_CUSTOMER_COMPANY'
export const SET_CUSTOMER_NO = 'SET_CUSTOMER_NO'
export const SET_CUSTOMER_FIRSTNAME = 'SET_CUSTOMER_FIRSTNAME'
export const SET_CUSTOMER_LASTNAME = 'SET_CUSTOMER_LASTNAME'
export const SET_CUSTOMER_STREET = 'SET_CUSTOMER_STREET'
export const SET_CUSTOMER_STREET_NO = 'SET_CUSTOMER_STREET_NO'
export const SET_CUSTOMER_POSTAL_CODE = 'SET_CUSTOMER_POSTAL_CODE'
export const SET_CUSTOMER_CITY = 'SET_CUSTOMER_CITY'
export const SET_CUSTOMER_COUNTRY = 'SET_CUSTOMER_COUNTRY'

export const SET_QUOTATION_DATE = 'SET_QUOTATION_DATE'
export const SET_INQUIRY_DATE = 'SET_INQUIRY_DATE'
export const SET_VALID_THROUGH = 'SET_VALID_THROUGH'
export const SET_USER_FIRSTNAME = 'SET_USER_FIRSTNAME'
export const SET_USER_LASTNAME = 'SET_USER_LASTNAME'
export const SET_USER_PHONE = 'SET_USER_PHONE'
export const SET_USER_EMAIL = 'SET_USER_EMAIL'

export const SET_USER_TERMS = 'SET_USER_TERMS'

export const RESET_QUOTATION = 'RESET_QUOTATION'

// ------------------------------------
// Actions
// ------------------------------------

export const setCustomerCompany = ({ customer_company }) => ({
    type: SET_CUSTOMER_COMPANY,
    customer_company
});
export const setCustomerNo = ({ customer_no }) => ({
    type: SET_CUSTOMER_NO,
    customer_no
});
export const setCustomerFirstname = ({ customer_firstname }) => ({
    type: SET_CUSTOMER_FIRSTNAME,
    customer_firstname
});
export const setCustomerLastname = ({ customer_lastname }) => ({
    type: SET_CUSTOMER_LASTNAME,
    customer_lastname
});
export const setCustomerStreet = ({ customer_street }) => ({
    type: SET_CUSTOMER_STREET,
    customer_street
});
export const setCustomerStreetNo = ({ customer_street_no }) => ({
    type: SET_CUSTOMER_STREET_NO,
    customer_street_no
});
export const setCustomerPostalCode = ({ customer_postal_code }) => ({
    type: SET_CUSTOMER_POSTAL_CODE,
    customer_postal_code
});
export const setCustomerCity = ({ customer_city }) => ({
    type: SET_CUSTOMER_CITY,
    customer_city
});
export const setCustomerCountry = ({ customer_country }) => ({
    type: SET_CUSTOMER_COUNTRY,
    customer_country
});
export const setQuotationDate = ({ quotation_date }) => ({
    type: SET_QUOTATION_DATE,
    quotation_date
});
export const setInquiryDate = ({ inquiry_date }) => ({
    type: SET_INQUIRY_DATE,
    inquiry_date
});
export const setValidThrough = ({ valid_through }) => ({
    type: SET_VALID_THROUGH,
    valid_through
});
export const setUserFirstname = ({ user_firstname }) => ({
    type: SET_USER_FIRSTNAME,
    user_firstname
});
export const setUserLastname = ({ user_lastname }) => ({
    type: SET_USER_LASTNAME,
    user_lastname
});
export const setUserPhone = ({ user_phone }) => ({
    type: SET_USER_PHONE,
    user_phone
});
export const setUserEmail = ({ user_email }) => ({
    type: SET_USER_EMAIL,
    user_email
});

export const setUserTerms = ({ user_terms }) => ({
    type: SET_USER_TERMS,
    user_terms
});

export const resetQuotation = () => ({
    type: RESET_QUOTATION
});

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
    customer_company: "",
    customer_no: "",
    customer_firstname: "",
    customer_lastname: "",
    customer_street: "",
    customer_street_no: "",
    customer_postal_code: "",
    customer_city: "",
    customer_country: "",
    quotation_date: "",
    inquiry_date: "",
    valid_through: "",
    user_firstname: "",
    user_lastname: "",
    user_phone: "",
    user_email: "",
    user_terms: "Term of payment" + "\n" +
    "Delviery Condition" + "\n" +
    "Lead time 2-3 weeks after receiving PO" + "\n" +
    "Sincely," + "\n" +
    "Max Musterman"
};

const quotation = (state = initialState, action) => {
    switch (action.type) {
        case SET_CUSTOMER_COMPANY:
            return {
                ...state,
                customer_company: action.customer_company,
            }
        case SET_CUSTOMER_NO:
            return {
                ...state,
                customer_no: action.customer_no,
            }
        case SET_CUSTOMER_FIRSTNAME:
            return {
                ...state,
                customer_firstname: action.customer_firstname,
            }
        case SET_CUSTOMER_LASTNAME:
            return {
                ...state,
                customer_lastname: action.customer_lastname,
            }
        case SET_CUSTOMER_STREET:
            return {
                ...state,
                customer_street: action.customer_street,
            }
        case SET_CUSTOMER_STREET_NO:
            return {
                ...state,
                customer_street_no: action.customer_street_no,
            }
        case SET_CUSTOMER_POSTAL_CODE:
            return {
                ...state,
                customer_postal_code: action.customer_postal_code,
            }
        case SET_CUSTOMER_CITY:
            return {
                ...state,
                customer_city: action.customer_city,
            }
        case SET_CUSTOMER_COUNTRY:
            return {
                ...state,
                customer_country: action.customer_country,
            }
        case SET_QUOTATION_DATE:
            return {
                ...state,
                quotation_date: action.quotation_date,
            }
        case SET_INQUIRY_DATE:
            return {
                ...state,
                inquiry_date: action.inquiry_date,
            }
        case SET_VALID_THROUGH:
            return {
                ...state,
                valid_through: action.valid_through,
            }
        case SET_USER_FIRSTNAME:
            return {
                ...state,
                user_firstname: action.user_firstname,
            }
        case SET_USER_LASTNAME:
            return {
                ...state,
                user_lastname: action.user_lastname,
            }
        case SET_USER_PHONE:
            return {
                ...state,
                user_phone: action.user_phone,
            }
        case SET_USER_EMAIL:
            return {
                ...state,
                user_email: action.user_email,
            }
        case SET_USER_TERMS:
            return {
                ...state,
                user_terms: action.user_terms,
            }
        case RESET_QUOTATION:
            return {
                ...state,
                customer_company: initialState.customer_company,
                customer_no: initialState.customer_no,
                customer_firstname: initialState.customer_firstname,
                customer_lastname: initialState.customer_lastname,
                customer_street: initialState.customer_street,
                customer_street_no: initialState.customer_street_no,
                customer_postal_code: initialState.customer_postal_code,
                customer_city: initialState.customer_city,
                customer_country: initialState.customer_country,
                quotation_date: initialState.quotation_date,
                inquiry_date: initialState.inquiry_date,
                valid_through: initialState.valid_through,
                user_firstname: initialState.user_firstname,
                user_lastname: initialState.user_lastname,
                user_phone: initialState.user_phone,
                user_email: initialState.user_email,
                user_terms: initialState.user_terms
            }
        default:
            return state
    }
}

export default quotation


// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/modules/quotation.js